var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-links"},[_c('ul',{staticClass:"am-cf"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"am-text-truncate"},[_c('a',{attrs:{"href":item.sub_title,"target":"_blank"}},[_vm._v("\n            "+_vm._s(item.title)+"\n            ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }